import platform from "platform"
// console.log(platform);
const platformPlugin = {
    install: function (Vue, options) {
        Vue.prototype.$platformDetect = platform
    }
}

export default platformPlugin